const CodeCell =  ({ coupon }) => (
    <p className="mb-0 text-dark text-hover-primary fw-bold">{coupon.code}</p>
)

export default CodeCell